import React, { useState, useEffect } from 'react';
import './futures-and-options-faq.m.css';
import faqData from './faq-data';
import FuturesAccordion from '../futures-accordion/accordion';
import { ArrowRightIcon } from '../../../../atoms/material-icons';
import { widgetLink } from '../../../../../helpers/utils';
import { BQLink } from '../../../../atoms/bqlink';

const FuturesAndOptionsFaq = ({ widget = false }) => {
  const widgetParam = widget ? '?view=apps' : '';
  const [initialLoading, setInitialLoading] = useState(true);
  const [isDarkMode, setIsDarkMode] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setInitialLoading(false);
    }, 1000);
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
    setIsDarkMode(mediaQuery.matches);

    const handleChange = (e) => setIsDarkMode(e.matches);
    mediaQuery.addEventListener('change', handleChange);

    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  if (initialLoading) {
    return <div styleName="initial-loading-container"></div>;
  }

  return (
    <div styleName="overall-faq-container">
      <h1 styleName="header-title">Futures and Options 101</h1>
      <div styleName="faq-container">
        <FuturesAccordion items={faqData} />
        <div styleName="btn-container">
          <BQLink
            styleName="view-more-btn"
            href={widgetLink(`/markets/filler-learn-more-about-futures-and-options${widgetParam}`)}
            target="_blank"
            rel="noreferrer"
          >
            Read More
            <ArrowRightIcon
              styleName="tab-icon"
              color={isDarkMode && widget ? '#FFFFFF' : '#2b2b2b'}
            />
          </BQLink>
        </div>
      </div>
    </div>
  );
};

export default FuturesAndOptionsFaq;
